import {
  Layout,
  Flex,
  Button,
  Space,
  Form,
  Progress, Spin,
} from "antd";

import { ArrowRightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Logo from "../Logo";
import useSurvey from "./useSurvey";
import Question from "./question";

import classes from "./survey.module.css";
import Background from "../Background";

const {
  Footer,
  Content
} = Layout;

const Survey = () => {
  const { t } = useTranslation();
  const {
    data,
    loading,
    error,
    percent,
    form,
    steps,
    handlePrevStep,
    handleNextStep,
    isNextStepDisabled,
    currentStep,
    initialValues
  } = useSurvey();

  if (!data) { // @TODO: to be replaced with global state
    // we don't have data yet

    if (loading) {
      // but we're loading some
      return <Spin spinning fullscreen />;
    }
    if (error) {
      // and we have an error
      return <h2>Error loading data :(</h2>;
    }
    return <h2>Unknown error :(</h2>;
  }

  return (
    <Layout style={{ height: "100%", minHeight: "100vh" }}>
      <Background step={steps.length - 1}/>
      <Content className={classes.content}>
        <Flex
          vertical
          justify="center"
          align="center"
          className={classes.title}
        >
          <Space className={classes.logo}>
            <Logo/>
          </Space>

          <Flex vertical align="center" gap={16} style={{ width: "100%" }}>
            <Progress percent={percent} showInfo={false} className={classes.progressBar}/>
            <Form
              form={form}
              name="questions"
              initialValues={initialValues}
              layout="vertical"
              style={{ width: "100%" }}
            >
              {data.questions.map((item) => (
                steps.includes(item.id)
                  ? <Question key={item.id} item={item} isVisible={item.id === currentStep}/>
                  : null
              ))}
            </Form>
          </Flex>
        </Flex>
      </Content>
      <Footer className={classes.footer}>
        <Flex className={classes.footerContent}>
          {steps.length > 1 ? (
            <Button
              type="link"
              size="large"
              onClick={handlePrevStep}
            >
              {t("survey.buttonPrev")}
            </Button>
          ) : null}

          <Button
            icon={<ArrowRightOutlined/>}
            type="primary"
            size="large"
            onClick={handleNextStep}
            disabled={isNextStepDisabled}
            style={{ marginLeft: "auto" }}
          >
            {t("survey.buttonNext")}
          </Button>
        </Flex>
      </Footer>
    </Layout>
  );
};

export default Survey;
